import { type ReactNode } from 'react';

import { classNames } from '../../../server/utils/classNames';

export type ListItemContentProps = {
	title: string | ReactNode;
	description?: string | ReactNode;
	contentLeft?: ReactNode;
	contentRight?: string | ReactNode;
	className?: string;
};

export const ListItemContent = ({ title, description, contentLeft, contentRight, className }: ListItemContentProps) => {
	return (
		<div className={classNames('flex w-full items-center grow h-12 gap-6', className)}>
			{contentLeft}
			<div className="flex w-full items-center justify-between gap-2 min-w-0">
				<div className="flex flex-col justify-center min-w-0">
					{typeof title === 'string' ? <span className="line-clamp-2">{title}</span> : title}
					{description &&
						(typeof description === 'string' ? (
							<span className="text-content-secondary line-clamp-1 text-body-sm sm:text-body">{description}</span>
						) : (
							description
						))}
				</div>
				{contentRight &&
					(typeof contentRight === 'string' ? (
						<span className="text-content-action-primary font-bold pl-6">{contentRight}</span>
					) : (
						contentRight
					))}
			</div>
		</div>
	);
};
